import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CSE_ID } from "../../../Config";

const GoogleSupport = ({ data = {}, question = 'test question' }) => {
    // const CSE_ID = '525947f1314584961';
    const [searchParams, setSearchParams] = useSearchParams();
    const [firstRender, setFirstRender] = useState(false);

    useEffect(() => {
        const scriptId = "google-cse-script";
        if (!document.getElementById(scriptId)) {
            const script = document.createElement("script");
            script.id = scriptId;
            script.src = `https://cse.google.com/cse.js?cx=${CSE_ID}`;
            script.async = true;
            document.body.appendChild(script);
        }

        return () => {
            const element = document.getElementById(scriptId);
            if (element) {
                element?.remove()
            }
            // document.body.removeChild(document.getElementById(scriptId));
        };

    }, []); // 🔹 Runs when query changes

    useEffect(() => {
        setSearchParams({ q: question }, { replace: true, state: data })
        setFirstRender(true)
    }, [])
    if (!firstRender) return <></>

    return (
        <div className="w-100">
            {/* 🔹 Google Search Results */}
            <div className="gcse-searchresults-only" data-gname="storesearch"></div>
        </div>
    );
};

export default GoogleSupport;
